import { gsap } from 'gsap';
// ScrollSmoother requires ScrollTrigger
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollSmoother } from 'gsap/ScrollSmoother';

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
export { gsap, ScrollTrigger, ScrollSmoother };
